export const CHER_BASE_URL = process.env.REACT_APP_API_URL;
export const DIONNE_BASE_URL = process.env.REACT_APP_DIONNE_API_URL;
export const WHERING_BASE_URL = process.env.REACT_APP_WHERING_API_BASE_URL;
